// import React, { useEffect, useState } from "react";
import React from "react";

const Content = (props) => {
  // const [playlists, setPlaylists] = useState([]);

  // useEffect(() => {
  //   // Fetch playlists data
  //   const fetchPlaylistsData = async () => {
  //     try {
  //       // Your YouTube Data API key
  //       const apiKey = "AIzaSyAYF2d7_WIceaDdTRHlw-FtIQPQp6KYu0o";

  //       // The ID of your YouTube channel
  //       const channelId = "UCw5YseCcfF5JrM3yjSmSzmQ";

  //       // Fetch the playlists data
  //       const response = await fetch(
  //         `https://www.googleapis.com/youtube/v3/playlists?part=snippet&maxResults=4&channelId=${channelId}&key=${apiKey}`
  //       );

  //       if (response.ok) {
  //         const data = await response.json();
  //         setPlaylists(data.items);
  //       } else {
  //         console.error("Failed to fetch playlists data");
  //       }
  //     } catch (error) {
  //       console.error("Error:", error);
  //     }
  //   };

  //   fetchPlaylistsData();
  // }, []);

  // const openPlaylist = (playlistId) => {
  //   window.open(
  //     `https://www.youtube.com/playlist?list=${playlistId}`,
  //     "_blank"
  //   );
  // };

  // const handleOpenClick = (playlistId) => {
  //   // Replace with your custom logic to handle the "Open" button click
  //   console.log(`Open button clicked for playlist ${playlistId}`);
  // };

  return (
    <section className={`text-gray-600 body-font bg-${props.mode}`}>
      {/* <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-wrap w-full mb-10">
          <div className="lg:w-1/2 w-full mb-6 lg:mb-0">
            <h1 className="sm:text-3xl text-2xl font-medium title-font mb-2 text-indigo-500">
              Recommended Playlists
            </h1>
            <div className="h-1 w-20 bg-purple-500 rounded"></div>
          </div>
          <p className="lg:w-1/2 w-full leading-relaxed text-purple-500"></p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {playlists.slice(0, 4).map((playlist, index) => {
            const { id, snippet = {} } = playlist;
            const { title, thumbnails = {} } = snippet;
            const { high = {} } = thumbnails;
            const playlistId = id;

            return (
              <div className="p-4" key={playlistId}>
                <div
                  className="block relative h-48 rounded overflow-hidden"
                  onClick={() => openPlaylist(playlistId)}
                >
                  <img
                    alt="playlist thumbnail"
                    className="object-cover object-center w-full h-full block"
                    src={high.url}
                  />
                </div>
                <div className="mt-4">
                  <h3 className="tracking-widest text-indigo-500 text-xs font-medium title-font">
                    Playlist {index + 1}
                  </h3>
                  <h2 className="text-lg text-gray-900 font-medium title-font mb-4">
                    {title}
                  </h2>
                </div>
                <div className="flex justify-between mt-4">
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    onClick={() => openPlaylist(playlistId)}
                  >
                    Open in YouTube
                  </button>
                  <button
                    className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                    onClick={() => handleOpenClick(playlistId)}
                  >
                    Open
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div> */}
    </section>
  );
};

export default Content;
